

































































import Vue from 'vue';
import LessonsListPanel from '@/web/components/products/LessonsListPanel';
import moment from 'moment';

export default Vue.extend({
  name: 'PrevNextLesson',
  components: {
    LessonsListPanel,
  },
  props: {
    product: {
      type: Object as () => ProductDetailResponse,
    },
    lesson: {
      type: Object as () => LessonResponse,
    },
    lessons: {
      type: Array as () => LessonResponse[],
    },
    hideNextButton: {
      type: Boolean,
      default: false,
    },
    hidePrevButton: {
      type: Boolean,
      default: false,
    },
    nextButtonLabel: {
      type: String,
    },
    prevButtonLabel: {
      type: String,
    },
    nextButtonDisabled: {
      type: Boolean,
      default: false,
    },
    hasAccess: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLessonsListPanelOpened: false,
    };
  },
  methods: {
    changeLessonsListPanelVisibility(value) {
      if (value) {
        this.isLessonsListPanelOpened = value;
      } else {
        this.isLessonsListPanelOpened = !this.isLessonsListPanelOpened;
      }
    },
    getAvailableAfterDate() {
      return moment(this.lesson.lesson_available_after_date).format(
        'MM-DD-YYYY'
      );
    },
    getAvailableAfterPurchase() {
      if (this.product.date_purchased) {
        const availibilityDate = moment(this.product.date_purchased).add(
          this.lesson.lesson_start_after_days,
          'days'
        );
        return moment(availibilityDate).diff(moment(), 'days');
      }
      return '';
    },
  },
  computed: {
    isLocked() {
      return !this.hasAccess || this.lesson.locked;
    },
    lessonAvailability() {
      switch (this.lesson.lesson_start_type) {
        case 'after_specific_date':
          return this.$t('PRODUCTS.TEXT.LESSON_WILL_BE_AVAILABLE_AFTER_DATE', {
            date: this.getAvailableAfterDate(),
          });
        case 'after_specific_days':
          return this.$t('PRODUCTS.TEXT.LESSON_WILL_BE_AVAILABLE_IN_DAYS', {
            days: this.getAvailableAfterPurchase(),
          });
        case 'after_previous_lesson':
          return this.$t(
            'PRODUCTS.TEXT.LESSON_AFTER_PREVIOUS_LESSON_HAS_COMPLETED'
          );
        case 'after_purchase':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_NOT_PURCHASED');
      }
      return '';
    },
  },
});
